import { GiftCardCheckoutScreen } from '../../../../../screens';

// ─────────────────────────────────────────────────────────────────────────────

export default function Page() {
  return <GiftCardCheckoutScreen />;
}
